import { $DKD } from '@/conf/common.const.js';
import commonApi from "@/api/common.api.js";

export default {
    state: {
        // 세출, 세입 탭 선택
        selectedFinance: 'expenditure',
        // 재정 세부사업별 예산현액 및 지출액 목록 (전체)
        expenditureList: [],
        // 신속집행
        quickExpenditureList: [],
        expenditureSearchList: [],
        expenditureYearList: [],
        // 지출 상세 내역
        expenditureDetailList: [],
        // 현재 선택된 세출 분야
        selectedExpenditureField: '',
        // 재정 세입내역
        revenueList: [],
        // 신속집행 대상 통계목 목록
        quickExecList: [],
        // 현재 선택된 세입 회계코드
        selectedRevenueFgCd: '',
        // 사업별 예산정보 팝업 여부
        showBizListWin: false,
        // 사업 상세창 팝업 여부
        showBizDetailWin: false,
        // 사업 상세창 iframe url
        bizDetailUrl: '',
        // 신속집행 부서별 추진실적 팝업 여부
        showQuickExecWin: false,
        // 구,시세계 여부
        gusiSummaryYn: '',
    },

    getters: {
        getSelectedFinance(state) {
            return state.selectedFinance;
        },
        getExpenditureList(state) {
            return state.expenditureList;
        },
        getQuickExpenditureList(state) {
            return state.quickExpenditureList;
        }, 
        getExpenditureSearchList(state) {
            return state.expenditureSearchList;
        },
        getExpenditureYearList(state) {
            return state.expenditureYearList;
        },
        getExpenditureDetailList(state) {
            return state.expenditureDetailList;
        },
        getSelectedExpenditureField(state) {
            return state.selectedExpenditureField;
        },
        getRevenueList(state) {
            return state.revenueList;
        },
        getQuickExecList(state) {
            return state.quickExecList;
        },
        getSelectedRevenueFgCd(state) {
            return state.selectedRevenueFgCd;
        },
        getGusiSummaryYn: function(state) {
        	return state.gusiSummaryYn;
        },
        getShowBizListWin(state) {
            return state.showBizListWin;
        },
        getShowBizDetailWin(state) {
            return state.showBizDetailWin;
        },
        getBizDetailUrl(state) {
            return state.bizDetailUrl;
        },
        getShowQuickExecWin(state) {
            return state.showQuickExecWin;
        },
    },

    mutations: {
        SELECTED_FINANCE(state, selectedFinance) {
            state.selectedFinance = selectedFinance;
        },
        EXPENDITURE_LIST(state, expenditureList) {
            state.expenditureList = expenditureList;
        },
        QUICK_EXPENDITURE_LIST(state, quickExpenditureList) {
            state.quickExpenditureList = quickExpenditureList;
        },
        EXPENDITURE_SEARCH_LIST(state, expenditureSearchList) {
            state.expenditureSearchList = expenditureSearchList;
        },
        EXPENDITURE_YEAR_LIST(state, expenditureYearList) {
            state.expenditureYearList = expenditureYearList;
        },
        EXPENDITURE_DETAIL_LIST(state, expenditureDetailList) {
            state.expenditureDetailList = expenditureDetailList;
        },
        SELECTED_EXPENDITURE_FIELD(state, selectedExpenditureField) {
            state.selectedExpenditureField = selectedExpenditureField;
        },
        REVENUE_LIST(state, revenueList) {
            state.revenueList = revenueList;
        },
        QUICK_EXEC_LIST(state, quickExecList) {
            state.quickExecList = quickExecList;
        },
        SELECTED_REVENUE_FG_CD(state, selectedRevenueFgCd) {
            state.selectedRevenueFgCd = selectedRevenueFgCd;
        },
        SELECTED_GUSI_SUMMARY_YN: function(state, gusiSummaryYn) {
        	state.gusiSummaryYn = gusiSummaryYn;
        },
        SHOW_BIZ_LIST_WIN(state, showBizListWin) {
            state.showBizListWin = showBizListWin;
        },
        SHOW_BIZ_DETAIL_WIN(state, showBizDetailWin) {
            state.showBizDetailWin = showBizDetailWin;
        },
        BIZ_DETAIL_URL(state, bizDetailUrl) {
            state.bizDetailUrl = bizDetailUrl;
        },
        SHOW_QUICK_EXEC_WIN(state, showQuickExecWin) {
            state.showQuickExecWin = showQuickExecWin;
        },
    },

    actions: {
        SET_SELECTED_FINANCE({commit}, selectedFinance) {
            commit("SELECTED_FINANCE", selectedFinance);
        },
        FETCH_EXPENDITURE_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.FINANCE_EXPENDITURE)
                .then(res => {
                    commit("EXPENDITURE_LIST", res.data.data);
                });
        },
        FETCH_EXPENDITURE_SEARCH_LIST({commit}, q) {
            return commonApi.fetchRepoDataList($DKD.FINANCE_EXPENDITURE, q)
                .then(res => {
                    commit("EXPENDITURE_SEARCH_LIST", res.data);
                });
        },
        SET_EXPENDITURE_YEAR_LIST({commit}, expenditureYearList) {
            commit("EXPENDITURE_YEAR_LIST", expenditureYearList);
        },
        FETCH_EXPENDITURE_DETAIL_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.FINANCE_EXPENDITURE_DETAIL)
                .then(res => {
                    commit("EXPENDITURE_DETAIL_LIST", res.data.data);
                });
        },
        SET_SELECTED_EXPENDITURE_FIELD({commit}, selectedExpenditureField) {
            commit("SELECTED_EXPENDITURE_FIELD", selectedExpenditureField);
        },
        FETCH_REVENUE_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.FINANCE_REVENUE)
                .then(res => {
                    commit("REVENUE_LIST", res.data.data);
                });
        },
        FETCH_QUICK_EXEC_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.FINANCE_QUICK_EXEC)
                .then(res => {
                    commit("QUICK_EXEC_LIST", res.data.data);
                });
        },
        SET_SELECTED_REVENUE_FG_CD({commit}, selectedRevenueFgCd) {
            commit("SELECTED_REVENUE_FG_CD", selectedRevenueFgCd);
        },
        SET_GUSI_SUMMARY_YN: function({commit}, gusiSummaryYn) {
        	commit("SELECTED_GUSI_SUMMARY_YN", gusiSummaryYn);
        },
        SET_SHOW_BIZ_LIST_WIN({commit}, showBizListWin) {
            commit("SHOW_BIZ_LIST_WIN", showBizListWin);
        },
        SET_SHOW_BIZ_DETAIL_WIN({commit}, showBizDetailWin) {
            commit("SHOW_BIZ_DETAIL_WIN", showBizDetailWin);
        },
        SET_BIZ_DETAIL_URL({commit}, bizDetailUrl) {
            commit("BIZ_DETAIL_URL", bizDetailUrl);
        },
        SET_SHOW_QUICK_EXEC_WIN({commit}, showQuickExecWin) {
            commit("SHOW_QUICK_EXEC_WIN", showQuickExecWin);
        },
    }
};
